import React, { useState } from 'react';
import { CheckTickLg, ChevronRightLg } from '@/icons';
import * as styles from './styles.module.scss';

interface SelectButtonProps {
  text: string;
  onClick?: () => void;
  canSelect?: boolean;
  isSelected?: boolean;
}

export const SelectButton: React.FC<SelectButtonProps> = ({ text, onClick, isSelected, canSelect }) => {
  const [isButtonSelected, setIsButtonSelected] = useState(isSelected);

  return (
    <button
      onClick={() => {
        setIsButtonSelected(!isButtonSelected);
        onClick?.();
      }}
      type='button'
      className={`${styles.button} ${isButtonSelected ? styles.selected : ''}`}
    >
      {text}
      {!canSelect && <ChevronRightLg title='Select to continue' />}
      {canSelect && isSelected && <CheckTickLg title='Selected' />}
    </button>
  );
};
